import { atom } from 'recoil';
import type { RecoilState } from 'recoil';
import { localStoragePersisterEffect } from 'utils/recoilEffects';
import { SRNA_PERSIST_TOKEN } from 'config/constants';

export type ReadCaseState = {
  workstationID: string | null;
};

// @ts-expect-error [EN-10263] - TS2322 - Type 'RecoilState<{ workstationID: null; }>' is not assignable to type 'RecoilState<ReadCaseState>'.
export const readCaseState: RecoilState<ReadCaseState> = atom({
  key: `${SRNA_PERSIST_TOKEN}readCaseState`,
  default: {
    workstationID: null,
  },
  effects: [localStoragePersisterEffect()],
});
